/**
 * @generated SignedSource<<578b4eee12b1f004184e0805daa795dd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RepositoryNameChip_repository$data = {
  readonly name: string;
  readonly owner: string;
  readonly " $fragmentType": "RepositoryNameChip_repository";
};
export type RepositoryNameChip_repository$key = {
  readonly " $data"?: RepositoryNameChip_repository$data;
  readonly " $fragmentSpreads": FragmentRefs<"RepositoryNameChip_repository">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RepositoryNameChip_repository",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "owner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Repository",
  "abstractKey": null
};

(node as any).hash = "6ca791ed113a04fd602a5d5beba5f806";

export default node;
